import {
  MenuProps as MantineMenuProps,
  Menu as MantineMenu,
  MenuTargetProps as MantineMenuTargetProps,
  MenuTarget as MantineMenuTarget,
  MenuDropdownProps as MantineMenuDropdownProps,
  MenuDropdown as MantineMenuDropdown,
  MenuItemProps as MantineMenuItemProps,
  MenuItem as MantineMenuItem,
  MenuSubProps as MantineMenuSubProps,
  MenuSub as MantineMenuSub,
  MenuSubTargetProps as MantineMenuSubTargetProps,
  MenuSubTarget as MantineMenuSubTarget,
  MenuSubDropdownProps as MantineMenuSubDropdownProps,
  MenuSubDropdown as MantineMenuSubDropdown,
  MenuSubItemProps as MantineMenuSubItemProps,
  MenuSubItem as MantineMenuSubItem,
} from '@mantine/core';

export type MenuProps = MantineMenuProps;
export type MenuTargetProps = MantineMenuTargetProps;
export type MenuDropdownProps = MantineMenuDropdownProps;
export type MenuItemProps = MantineMenuItemProps;
export type MenuSubProps = MantineMenuSubProps;
export type MenuSubTargetProps = MantineMenuSubTargetProps;
export type MenuSubDropdownProps = MantineMenuSubDropdownProps;
export type MenuSubItemProps = MantineMenuSubItemProps;

export const Menu = MantineMenu;
Menu.displayName = 'Menu';

export const MenuTarget = MantineMenuTarget;
MenuTarget.displayName = 'MenuTarget';

export const MenuDropdown = MantineMenuDropdown;
MenuDropdown.displayName = 'MenuDropdown';

export const MenuItem = MantineMenuItem;
MenuItem.displayName = 'MenuItem';

export const MenuSub = MantineMenuSub;
MenuSub.displayName = 'MenuSub';

export const MenuSubTarget = MantineMenuSubTarget;
MenuSubTarget.displayName = 'MenuSubTarget';

export const MenuSubDropdown = MantineMenuSubDropdown;
MenuSubDropdown.displayName = 'MenuSubDropdown';

export const MenuSubItem = MantineMenuSubItem;
MenuSubItem.displayName = 'MenuSubItem';

// Attach subcomponents to Menu for dot notation access
Menu.Sub = MenuSub;
Menu.Item = MenuItem;
